/* Progressive enhancement for the store's existing .sg-pdp-360 markup. */
(function () {
  'use strict';
  if (window.SGPDP360Interactive) return;
  var instances = new Map();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(viewer) {
    if (instances.has(viewer)) return;
    var frames = Number(viewer.getAttribute('data-sg-360-frames') || 30);
    if (!Number.isInteger(frames) || frames < 2 || frames > 360) return;
    var interval = Number(viewer.getAttribute('data-sg-360-interval') || 110);
    if (!Number.isFinite(interval) || interval < 40) interval = 110;
    var frame = 0;
    var paused = reduced.matches;
    var inView = false;
    var timer = null;
    var pointer = null;
    var disposed = false;
    var wrap = viewer.closest('.sg-pdp-360-wrap');
    if (!wrap) return;
    var controls = document.createElement('div');
    controls.className = 'sg-360-controls';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', '360-degree view controls');
    function button(text, label) {
      var el = document.createElement('button');
      el.type = 'button';
      el.textContent = text;
      el.setAttribute('aria-label', label);
      controls.appendChild(el);
      return el;
    }
    var previous = button('←', 'Previous angle');
    var play = button('Pause rotation', 'Pause rotation');
    var next = button('→', 'Next angle');
    var hint = document.createElement('p');
    hint.className = 'sg-360-hint';
    hint.textContent = 'Drag left or right. Tap for the next angle. Arrow keys also work.';
    viewer.after(hint, controls);
    viewer.setAttribute('data-sg-360-ready', 'true');
    viewer.tabIndex = 0;
    viewer.setAttribute('role', 'slider');
    viewer.setAttribute('aria-roledescription', '360-degree product viewer');
    viewer.setAttribute('aria-valuemin', '1');
    viewer.setAttribute('aria-valuemax', String(frames));
    viewer.setAttribute('aria-orientation', 'horizontal');

    function draw(value) {
      frame = ((Math.round(value) % frames) + frames) % frames;
      viewer.style.backgroundPosition = (frame * 100 / (frames - 1)) + '% 0';
      viewer.setAttribute('data-sg-360-frame', String(frame));
      viewer.setAttribute('aria-valuenow', String(frame + 1));
      viewer.setAttribute('aria-valuetext', 'View ' + (frame + 1) + ' of ' + frames);
    }
    function stopTimer() { if (timer !== null) { clearInterval(timer); timer = null; } }
    function sync() {
      stopTimer();
      play.textContent = paused ? 'Play rotation' : 'Pause rotation';
      play.setAttribute('aria-label', play.textContent);
      if (!disposed && !paused && inView && !document.hidden && !pointer) {
        timer = setInterval(function () { draw(frame + 1); }, interval);
      }
    }
    function manual(value) { paused = true; draw(value); sync(); }
    previous.addEventListener('click', function () { manual(frame - 1); });
    next.addEventListener('click', function () { manual(frame + 1); });
    play.addEventListener('click', function () { paused = !paused; sync(); });
    viewer.addEventListener('keydown', function (event) {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End', ' ', 'Enter'].indexOf(event.key) === -1) return;
      event.preventDefault();
      if (event.key === 'ArrowLeft') manual(frame - 1);
      if (event.key === 'ArrowRight') manual(frame + 1);
      if (event.key === 'Home') manual(0);
      if (event.key === 'End') manual(frames - 1);
      if (event.key === ' ' || event.key === 'Enter') { paused = !paused; sync(); }
    });
    viewer.addEventListener('pointerdown', function (event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, frame: frame, dragging: false };
      stopTimer();
      viewer.setPointerCapture(event.pointerId);
    });
    viewer.addEventListener('pointermove', function (event) {
      if (!pointer || pointer.id !== event.pointerId) return;
      var dx = event.clientX - pointer.x;
      var dy = event.clientY - pointer.y;
      if (!pointer.dragging && Math.abs(dx) < 6) return;
      if (!pointer.dragging && Math.abs(dy) > Math.abs(dx)) return;
      pointer.dragging = true;
      paused = true;
      viewer.setAttribute('data-sg-360-dragging', 'true');
      draw(pointer.frame + dx / Math.max(6, viewer.clientWidth / frames));
      play.textContent = 'Play rotation';
      play.setAttribute('aria-label', 'Play rotation');
    });
    function endPointer(event, cancelled) {
      if (!pointer || pointer.id !== event.pointerId) return;
      var tap = !cancelled && !pointer.dragging && Math.abs(event.clientX - pointer.x) < 6 && Math.abs(event.clientY - pointer.y) < 6;
      pointer = null;
      viewer.removeAttribute('data-sg-360-dragging');
      if (viewer.hasPointerCapture(event.pointerId)) viewer.releasePointerCapture(event.pointerId);
      if (tap) { paused = true; draw(frame + 1); }
      sync();
    }
    viewer.addEventListener('pointerup', function (event) { endPointer(event, false); });
    viewer.addEventListener('pointercancel', function (event) { endPointer(event, true); });
    viewer.addEventListener('lostpointercapture', function () { if (pointer) { pointer = null; viewer.removeAttribute('data-sg-360-dragging'); sync(); } });
    viewer.addEventListener('focus', function () { paused = true; sync(); });
    var observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; sync(); }, { threshold: 0.1 });
      observer.observe(viewer);
    } else { inView = true; }
    function motionChange() { if (reduced.matches) { paused = true; sync(); } }
    reduced.addEventListener('change', motionChange);
    document.addEventListener('visibilitychange', sync);
    draw(0);
    sync();
    instances.set(viewer, function () {
      disposed = true; stopTimer(); if (observer) observer.disconnect();
      document.removeEventListener('visibilitychange', sync); reduced.removeEventListener('change', motionChange);
      controls.remove(); hint.remove(); instances.delete(viewer);
    });
  }
  function init(root) { root.querySelectorAll('.sg-pdp-360[data-sg-360-interactive]').forEach(setup); }
  window.SGPDP360Interactive = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, viewer) { if (event.target.contains(viewer)) dispose(); });
  });
})();
